import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipoDocumentiListComponent.vue?vue&type=template&id=00c7fa50"
import script from "./ConfigurazioneContabilitaTipoDocumentiListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipoDocumentiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports